export const POSITION_CALCULATION_MODES = {
  POSITIONS: "positions",
  POSITIONS_FILLED_TRADES: "positions_filled_trades",
  POSITIONS_ALL_TRADES: "positions_all_trades",
};

export const POSITION_CALCULATION_MODE_OPTIONS = [
  { value: POSITION_CALCULATION_MODES.POSITIONS, label: "Positions" },
  {
    value: POSITION_CALCULATION_MODES.POSITIONS_FILLED_TRADES,
    label: "Positions + Filled Trades",
  },
  {
    value: POSITION_CALCULATION_MODES.POSITIONS_ALL_TRADES,
    label: "Positions + All Trades",
  },
];

export const DEFAULT_POSITION_CALCULATION_MODE =
  POSITION_CALCULATION_MODES.POSITIONS_FILLED_TRADES;

export const NAV_DENOMINATOR_MODES = {
  ACCOUNTING: "accounting",
  CALCULATED: "calculated",
};

export const NAV_DENOMINATOR_MODE_OPTIONS = [
  { value: NAV_DENOMINATOR_MODES.ACCOUNTING, label: "Accounting AUM" },
  { value: NAV_DENOMINATOR_MODES.CALCULATED, label: "Capital" },
];

export const DEFAULT_NAV_DENOMINATOR_MODE = NAV_DENOMINATOR_MODES.ACCOUNTING;

export function isCalculatedNavMode(mode) {
  return mode === NAV_DENOMINATOR_MODES.CALCULATED;
}

/** Maps reducer mode to MonitorScreenCalculation filled/trades args. */
export function getMonitorScreenTradeParams(mode, trades = []) {
  switch (mode) {
    case POSITION_CALCULATION_MODES.POSITIONS:
      return { filled: false, trades: [] };
    case POSITION_CALCULATION_MODES.POSITIONS_FILLED_TRADES:
      return { filled: true, trades };
    case POSITION_CALCULATION_MODES.POSITIONS_ALL_TRADES:
      return { filled: false, trades };
    default:
      return { filled: true, trades };
  }
}
